
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["incomestat_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M142.609 154.608h80.996v712.464h-80.996z"}}),_c('path',{attrs:{"d":"M190.376 807.076H902.84v59.996H190.376zm137.428-264.554h66.792v178.491h-66.792z"}}),_c('path',{attrs:{"d":"M207.375 786.076h712.464v80.996H207.375zm246.434-401.979H520.6v336.917h-66.791zm124.494 82.496h66.791v254.421h-66.791zm145.493-256.488h66.791v510.909h-66.791z"}})])
          )
        }
      }
    